import { useDimensions } from "@repo/core/hooks/useDimensions";
import { RedeemPointsModalProps } from "./types";
import { useState } from "react";
export const useRedeemPointsModalController = ({
  pointsList,
  onRedeem,
  onSkip
}: RedeemPointsModalProps) => {
  const { isMobile } = useDimensions();
  const [selectedPoints, setSelectedPoints] = useState<string>("");

  const handleRedeem = () => {
    if (selectedPoints) {
      onRedeem(Number(selectedPoints));
    }
  };

  const handleSkip = () => {
    onSkip();
  };

  return {
    isMobile,
    pointsList,
    selectedPoints,
    setSelectedPoints,
    handleRedeem,
    handleSkip
  };
};
